<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Video Tutorials</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Video Tutorials
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="users-view">
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <h3 class="mb-1"><i class="feather icon-info"></i>Tutorial Details</h3>

                                    <table class="table table-borderless">
                                        <tbody>
                                        <tr>
                                            <td>Title:</td>
                                            <td>{{ tutorial.title }}</td>
                                        </tr>
                                        <tr>
                                            <td>Description:</td>
                                            <td>
                                                {{ tutorial.description }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>

                                    <video v-if="tutorial.link"
                                        controls
                                        class="w-100 mt-3"
                                        style="max-height: 450px; border-radius: 6px;">
                                        <source :src="tutorial.link" type="video/mp4">
                                    </video>
                                    <p v-else>Video link not found</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo: {title: 'Tutorials'},
    name: 'TutorialsShow',
    props: ['tutorial'],
    layout: Layout,
    data: () => ({
        saving: false,
        errors: {}
    }),
    methods: {
    },
    mounted() {

    },
}
</script>
